import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneAC_NT_AS_AwardSource = createAsyncThunk(
  "AC_NT_AS_AwardSource/GetOneAC_NT_AS_AwardSource",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_AS_AwardSource/GetOneAC_NT_AS_AwardSource",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAC_NT_AS_AwardSource = createAsyncThunk(
  "AC_NT_AS_AwardSource/UpdateAC_NT_AS_AwardSource",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_AS_AwardSource/UpdateAC_NT_AS_AwardSource",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAC_ST_ASD_AwardSourceDropdown = createAsyncThunk(
  "AC_NT_AS_AwardSource/GetAllAC_ST_ASD_AwardSourceDropdown",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AC_ST_ASD_AwardSourceDropdown/GetAllAC_ST_ASD_AwardSourceDropdown",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dfdfdfdfdfdf");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const AwardSource = createSlice({
  name: "AwardSource",
  initialState: {
    //------------- GetAwardSource ---------------------
    AwardSource: {},
    loadingAwardSource: false,
    errorAwardSource: null,
    //------------- UpdateAwardSource ---------------------
    UpdateAwardSource: {},
    loadingUpdateAwardSource: false,
    errorUpdateAwardSource: null,
    //------------- AwardSourceDropdown ---------------------
    AwardSourceDropdown: [],
    loadingAwardSourceDropdown: false,
    errorAwardSourceDropdown: null,
  },
  reducers: {
    setAwardSource: (state, action) => {
      state.AwardSource = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneAC_NT_AS_AwardSource.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingAwardSource = true;
        state.AwardSource = action.payload;
        state.errorAwardSource = null;
      })
      .addCase(GetOneAC_NT_AS_AwardSource.fulfilled, (state, action) => {
        state.loadingAwardSource = false;
        state.AwardSource = action.payload;
      })
      .addCase(GetOneAC_NT_AS_AwardSource.rejected, (state, action) => {
        state.loadingAwardSource = false;
        state.AwardSource = action.payload;
      });
    //------------------- UpdateAwardSource -----------------------------------
    builder
      .addCase(UpdateAC_NT_AS_AwardSource.pending, (state, action) => {
        state.loadingUpdateAwardSource = true;
        state.UpdateAwardSource = action.payload;
        state.errorUpdateAwardSource = null;
      })
      .addCase(UpdateAC_NT_AS_AwardSource.fulfilled, (state, action) => {
        state.loadingUpdateAwardSource = false;
        state.UpdateAwardSource = action.payload;
      })
      .addCase(UpdateAC_NT_AS_AwardSource.rejected, (state, action) => {
        state.loadingUpdateAwardSource = false;
        state.errorUpdateAwardSource = action.payload;
      });
    //--------------------------AwardSourceDropdown--------------------------
    builder
      .addCase(GetAllAC_ST_ASD_AwardSourceDropdown.pending, (state, action) => {
        state.loadingAwardSourceDropdown = true;
        state.AwardSourceDropdown = action.payload;
        state.errorAwardSourceDropdown = null;
      })
      .addCase(
        GetAllAC_ST_ASD_AwardSourceDropdown.fulfilled,
        (state, action) => {
          state.loadingAwardSourceDropdown = false;
          state.AwardSourceDropdown = action.payload;
        }
      )
      .addCase(
        GetAllAC_ST_ASD_AwardSourceDropdown.rejected,
        (state, action) => {
          state.loadingAwardSourceDropdown = false;
          state.errorAwardSourceDropdown = action.payload;
        }
      );
  },
});
export const { setAwardSource } = AwardSource.actions;

export default AwardSource.reducer;
